<button
  mat-flat-button
  class="genericButton"
  [disabled]="disabled"
  [color]="color"
  (click)="clickEvent()"
  [textContent]="textContent"
></button>
